import Reveal from "../components/Reveal";
import { Quote } from "lucide-react";

const QUOTES = [
  {
    text: "Joba removed a load-bearing wall and nobody would ever know it existed. The kitchen feels like it was always meant to be this way.",
    name: "Elena & Marcus Whitfield",
    project: "Bellevue Kitchen Atelier",
  },
  {
    text: "Weekly photo updates, zero surprises on the invoice, and a bathroom the whole family loves. Unheard of in this industry.",
    name: "David Okafor",
    project: "Hall Bathroom Renewal",
  },
  {
    text: "They rebuilt our front yard stonework when two other contractors said the grades couldn't be matched. The curb appeal is unrecognizable.",
    name: "Priya Raman",
    project: "Curbside Stone & Masonry",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="mx-auto max-w-7xl px-4 py-24 sm:px-8 lg:py-32">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-copper">Client voices</p>
        <h2 className="mt-4 max-w-xl font-display text-4xl font-semibold tracking-tight text-cream sm:text-5xl">
          Trusted with the keys to remarkable homes.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-3">
        {QUOTES.map((q, i) => (
          <Reveal key={q.name} delay={i * 0.08} className="h-full">
            <figure
              data-testid={`testimonial-card-${i}`}
              className="flex h-full flex-col gap-6 rounded-2xl border border-line bg-surface p-8 transition-transform duration-500 hover:-translate-y-1.5"
            >
              <Quote size={22} className="text-copper" />
              <blockquote className="text-sm leading-relaxed text-cream/75">{q.text}</blockquote>
              <figcaption className="mt-auto">
                <p className="font-display text-base font-semibold text-cream">{q.name}</p>
                <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-copper">
                  {q.project}
                </p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
